var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "width": "95%",
      "height": "auto",
      "is-loc": "bottom"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "energy__img"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/diamond.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "energy__title"
  }, [_vm._v(" Diamond ")]), _c('div', {
    staticClass: "energy__subtitle"
  }, [_vm._v(" 1、Diamonds can participate in SoloJack to win big prizes. "), _c('br'), _vm._v(" 2、Buying boxes can earn more Diamonds. ")]), _c('div', {
    staticClass: "btn-level",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" GO ")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };